import { useLocation } from 'react-router-dom';

export const useLocationSearch = () => {
    const location = useLocation();
    return (url: string) => {
        return `${url}${location.search}`;
    }

}